"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KettePropertiesDetails = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Kette properties that are used by the individual applications detail requests.
 */
class KettePropertiesDetails {
}
exports.KettePropertiesDetails = KettePropertiesDetails;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE, _c = echain_shared_igus_fundamentals_1.AppName.EIC, _d = echain_shared_igus_fundamentals_1.AppName.ECF;
KettePropertiesDetails[_a] = [
    'Id',
    'EchainId',
    'AdapterLinkRef',
    'ArtNr',
    'ArtNrUS',
    'ArtNrDE',
    'ArtSerieBreite',
    'ArticleSpecs',
    'ArticleType',
    'Aussenbreite',
    'Aussenhoehe',
    'AutoglideLinkRef',
    'Bauform',
    'Bezeichnung',
    'Bi1',
    'Bi2',
    'Biegeradius',
    'ContractedLength',
    'D1',
    'D1Klein',
    'D2Klein',
    'EchainSystem',
    'EcpRef',
    'EffektiveLaenge',
    'FreigabeEIQ',
    'FreitragenderBetriebErlaubt',
    'GewichtKgProM',
    'GleitenderBetriebErlaubt',
    'Halbstegig',
    'IAFreespace',
    'IndexBiegeradius',
    'IndexBreite',
    'Innenbreite',
    'Innenhoehe',
    'IproProduktgruppenId',
    'K',
    'K2',
    'K3',
    'KetteSerieType',
    'LangerWegZeichnungsnummer',
    'LeitungDiameterMax',
    'MaxCablesPerChamber',
    'MinDistKlemmO',
    'MinDistKlemmU',
    'MinDistO',
    'MinDistU',
    'ModifiedLinkRef',
    'MontagesetRef',
    'NoSeparaterFootBottom',
    'NoSeparaterFootTop',
    'NumFirstOtherLinks',
    'NumGlieder',
    'PushPullForceMax',
    'RadiusAussen',
    'RastPosDist',
    'RinneRef',
    'RinnenvarianteRef',
    'RolLinkRef',
    'Rotationswinkel',
    'SerieRef',
    'SerienKurzbezeichnung',
    'SmartPlasticsECWAllowed',
    'StandardLinkRef',
    'StandardTrennstegArtNr',
    'StaticIAArtikelRef',
    'Teilung',
    'UngeradeAnzahlGlieder',
    'VersatzFestpunktErlaubt',
    'X1',
];
KettePropertiesDetails[_b] = [
    'Id',
    'EchainId',
    'AdapterLinkRef',
    'ApproxGewichtKgProM',
    'ApproxVerfahrwegToEffektiveLaenge',
    'ArtNr',
    'ArtNrUS',
    'ArtNrDE',
    'ArtSerieBreite',
    'ArticleSpecs',
    'ArticleType',
    'Aussenbreite',
    'Aussenhoehe',
    'AutoglideLinkRef',
    'Bauform',
    'BelastungFLB',
    'BelastungFLG',
    'BeschleunigungFLBMax',
    'BeschleunigungFLGMax',
    'BeschleunigungGleitendMax',
    'Bezeichnung',
    'Bi1',
    'Bi2',
    'Biegeradius',
    'ContractedLength',
    'D',
    'D1',
    'D1Klein',
    'D2Klein',
    'EchainSystem',
    'EffektiveLaenge',
    'EinbauartFreitragendErlaubt',
    'EinbauartGleitendErlaubt',
    'EinbauartHaengendErlaubt',
    'FZGleitendMax',
    'FreigabeEIC',
    'FreigabeEKE',
    'FreigabeEKEManualMode',
    'FreitragenderBetriebErlaubt',
    'GeschwindigkeitFLBMax',
    'GeschwindigkeitFLGMax',
    'GeschwindigkeitGleitendMax',
    'GewichtKgProM',
    'GleitenderBetriebErlaubt',
    'H',
    'Halbstegig',
    'HoeheVorspannung',
    'IAFreespace',
    'IndexBiegeradius',
    'IndexBreite',
    'Innenbreite',
    'Innenhoehe',
    'IproProduktId',
    'IproProduktgruppenId',
    'K',
    'K2',
    'K3',
    'KetteSerieType',
    'LangerWegZeichnungsnummer',
    'LeitungDiameterMax',
    'MaxCablesPerChamber',
    'MinBauraumGleitendRinneRefs',
    'MinDistKlemmO',
    'MinDistKlemmU',
    'MinDistO',
    'MinDistU',
    'ModifiedLinkRef',
    'MontagesetRef',
    'NoSeparaterFootBottom',
    'NoSeparaterFootTop',
    'NumFirstOtherLinks',
    'NumGlieder',
    'OpeningPrinciple',
    'OpeningPrincipleLabel',
    'PushPullForceMax',
    'RadiusAussen',
    'RastPosDist',
    'RinneRef',
    'RinnenvarianteRef',
    'RolLinkRef',
    'Rotationswinkel',
    'SerieRef',
    'SerienKurzbezeichnung',
    'SmartPlasticsECWAllowed',
    'StandardLinkRef',
    'StandardTrennstegArtNr',
    'StaticIAArtikelRef',
    'Teilung',
    'UngeradeAnzahlGlieder',
    'VersatzFestpunktErlaubt',
    'WidenBildId',
    'WidenZeichnungId',
    'X1',
];
KettePropertiesDetails[_c] = KettePropertiesDetails[echain_shared_igus_fundamentals_1.AppName.EKE];
KettePropertiesDetails[_d] = ['EchainId'];
//# sourceMappingURL=KettePropertiesDetails.js.map